import NodeEvents from 'events';
import * as Inovx from '@shared';
import OrganizationConstants from '../constants/OrganizationConstants';

var EventEmitter = NodeEvents.EventEmitter;

var CHANGE_EVENT = 'Organization.change';

var _parent: IOrganizationBaseDetail = null,
    _currentList: IOrganizationBase[] = [],
    _currentOrganization: IOrganizationBase = getBlankOrganization(),
    _editOrganization: IItemDataDetail | any = getBlankOrganizationDetail(),
    _hasChanges = false,
    _isEditingOrganization: boolean = false,
    _allRoles: IOrganizationRole[] = [];

function setEditingOrganization(organization: IItemDataDetail) {
    _currentOrganization = organization;
    _isEditingOrganization = true;
    _editOrganization = { ...organization };
    _hasChanges = false;
}

function _updateEditOrganization(key: string, value: any) {
    _editOrganization[key] = value;
    _hasChanges = true;
}

function finishEditing() {
    _isEditingOrganization = false;
    _hasChanges = false;
}

function getBlankOrganization(): IOrganizationBase {
    return { Name: '', OrganizationType: '', ID: '', Description: '', TypeName: '', VersionToken: '', ItemType: 3 };
}

function getBlankOrganizationDetail(): IItemDataDetail {
    return { Name: '', OrganizationType: '', ID: '', Description: '', TypeName: '', VersionToken: '', ItemType: 3, AssignedRoles: [], InheritAccessRightFromID: "", Type: null };
}

var OrganizationStore: IOrganizationStore = Object.assign({}, EventEmitter.prototype, {
    getCurrentList: function () {
        return _currentList;
    },
    getCurrentOrganization: function () {
        return _currentOrganization;
    },
    getEditOrganization: function () {
        return _editOrganization;
    },
    getCurrentParent: function () {
        return _parent;
    },
    getHasChanges: function () {
        return _hasChanges;
    },
    getIsEditing: function () {
        return _isEditingOrganization;
    },
    getAllRoles: function () {
        return _allRoles;
    },
    emitChange: function () {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener: function (callback: any) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function (callback: any) {
        this.removeListener(CHANGE_EVENT, callback);
    }
});

Inovx.Shared.Flux.AppDispatcher.register(function (payload: any) {
    switch (payload.actionType) {
        case OrganizationConstants.ORGANIZATION_BEGIN_EDIT:
            setEditingOrganization(payload.organization);
            break;
        case OrganizationConstants.ORGANIZATION_END_EDIT:
            finishEditing();
            break;
        case OrganizationConstants.ORGANIZATION_RECIEVE_ROOTS:
        case OrganizationConstants.ORGANIZATION_RECIEVE_CHILDREN:
            _parent = payload.parent;
            _currentList = payload.data;
            break;
        case OrganizationConstants.ORGANIZATION_UPDATE_ORGANIZATION:
            _updateEditOrganization(payload.key, payload.value);
            break;
        case OrganizationConstants.ORGANIZATION_RECEIVE_ALL_ROLES:
            _allRoles = payload.roles;
            break;
        default: return true;
    }

    OrganizationStore.emitChange();

    return true;
});

export default OrganizationStore;
